export default function ErrorPage() {
  return <h1>Oops! Page not found.</h1>;
}
